import { connect } from 'react-redux';
import { setFlatIdAction, setHouseIdAction, setHoveredFlatIdAction, setHoveredSectionIdAction, setMVKPhaseAction, setSectionIdAction } from '../actions/mvk_state';
import { SideBlockHousePicker } from '../components/side_block_house_picker';
import { MVKPhase } from '../types/mvk_state';
import { getOfferViewModels, getSimilarOffers } from '../utils/parsers/flats';
import { HouseUtils } from '../utils/parsers/houses';
function mapStateToProps(state) {
  var houseUtils = HouseUtils.getInstance(state.MVKData);
  var selectedHouseId = state.MVKState.house.id;
  var selectedSectionId = state.MVKState.section.id;
  var isPreview = state.MVKState.phase === MVKPhase.PREVIEW;
  var isFlatPlanView = state.MVKState.phase === MVKPhase.SECTION;
  var isFlatView = state.MVKState.phase === MVKPhase.FLAT;
  var filters = state.MVKState.sectionPhaseFilters;
  var _state$MVKState = state.MVKState,
    house = _state$MVKState.house,
    section = _state$MVKState.section,
    flat = _state$MVKState.flat;
  var parsedSections = houseUtils.getSections();
  var selectedSection = parsedSections.find(function (item) {
    return item.id === selectedSectionId;
  });
  return {
    currentPhase: state.MVKState.phase,
    geoInfo: state.MVKData.geoInfo,
    hoveredId: flat.hoveredId || section.hoveredId || house.hoveredId,
    newbuildingName: state.MVKData.name,
    parsedOffers: isFlatPlanView && selectedHouseId && selectedSectionId ? getOfferViewModels(state.MVKData, selectedHouseId, selectedSectionId, filters) : [],
    parsedSections: isPreview ? parsedSections : [],
    parsedSimilarOffers: isFlatView ? getSimilarOffers(state.MVKData, state.MVKState.flat.id) : [],
    sectionPhaseFilters: state.MVKState.sectionPhaseFilters,
    selectedSection: selectedSection,
    shouldIgnoreScroll: state.MVKState.shouldIgnoreScroll,
    isOfferCard: state.MVKState.isOfferCard
  };
}
function mapDispatchToProps(dispatch) {
  return {
    clearFlatId: function clearFlatId() {
      return dispatch(setMVKPhaseAction(MVKPhase.SECTION));
    },
    clearSectionId: function clearSectionId() {
      return dispatch(setMVKPhaseAction(MVKPhase.PREVIEW));
    },
    setFlatId: function setFlatId(id) {
      return dispatch(setFlatIdAction(id));
    },
    setHouseId: function setHouseId(id) {
      return dispatch(setHouseIdAction(id));
    },
    setHoveredFlatId: function setHoveredFlatId(flatId) {
      return dispatch(setHoveredFlatIdAction(flatId));
    },
    setHoveredSectionId: function setHoveredSectionId(id, houseId, shouldIgnoreScroll) {
      return dispatch(setHoveredSectionIdAction(id, houseId, shouldIgnoreScroll));
    },
    setSectionId: function setSectionId(id) {
      return dispatch(setSectionIdAction(id));
    }
  };
}
export var SideBlockHousePickerContainer = connect(mapStateToProps, mapDispatchToProps)(SideBlockHousePicker);